import { INVALID_TOKEN, REFRESHING_TOKEN, REFRESH_EXPIRED } from '../actions/types';
// import { INVALID_TOKEN, REFRESHING_TOKEN, REFRESH_EXPIRED, TOKEN_REFRESHED } from '../actions/types';
// import * as Accion from '../actions';

// We have access to store.getState() to get the current state and store.dispatch() to dispatch a new action
const RefreshMiddleware = store => next => action => {
  if (action.type === INVALID_TOKEN) {
    if (store.getState().app) {
      if (!store.getState().app.refreshingTokenPending) {
        store.dispatch({ type: REFRESHING_TOKEN });

        //store.dispatch(Accion.refrescarTokenEnApi())
        //  .then(() => {
        //    store.dispatch({ type: TOKEN_REFRESHED });
        //    switch (action.funcion) {
        //      //case 'checkStatusEnApi':
        //      //  store.dispatch(Accion.checkStatusEnApi());
        //      //  return 'OK';
        //      default:
        //        return 'OK';
        //    }
        //  });
      }
    }
  } else if (action.type === REFRESH_EXPIRED) {
    // Si no hago esto se entra en bucle
    // store.dispatch(Accion.logoutEnApi());
  } else {
    return next(action);
  }

  return null;
};

export default RefreshMiddleware;
